import { Link as RouterLink } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import HeartBrokenIcon from '@mui/icons-material/HeartBroken';
import MainImageCardDashboard from "../../../components/Cards/MainImageCardDashboard";
import HeaderCardSmall from "../../../components/Header/HeaderCardSmall";
import { cvd } from "../../../constants";


export default function CVCard() {

return (
<>

    <MainImageCardDashboard

        content = {<HeaderCardSmall cardheadline={'Cardiovascular Health'} /> }

        iconbuttons = {<>               

                        <Tooltip title="CV Health" placement="bottom">
                                <IconButton component={RouterLink} to="/CVDWelcome" size="large">
                                        <HeartBrokenIcon sx={{color: 'common.white', '&:hover': { color: 'common.white'}, }}/>
                                </IconButton>
                        </Tooltip>               
                 </>}  

        photo = { cvd }  

    />

</>
)};
